{
  "pipes": {
    "appointment_status": {
      "BLOCKER": "Blocker",
      "CONFIRMED": "Confirmed",
      "CHECKED_IN": "Checked in",
      "FULFILLED": "Checked out",
      "BO_CANCELLED": "Salon canceled",
      "CUSTOMER_CANCELLED": "Customer canceled",
      "EXPIRED": "Expired",
      "OTHER": "Other"
    },
    "booking_type": {
      "BLOCKER": "Blocker",
      "AGENT": "AI Agent",
      "TELEPHONE": "Telephone",
      "ONLINE": "Internet",
      "TREATWELL": "Treatwell",
      "RWG": "Google"
    },
    "communication_way": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "no_matter": "No matter"
    },
    "customer_type": {
      "vip": "VIP",
      "new": "New customer",
      "regular": "Regular customer",
      "at_risk": "At risk customer",
      "normal": "Normal customer"
    },
    "language": {
      "cs-CZ": "Czech",
      "de-DE": "German",
      "fr-FR": "French",
      "en-US": "English",
      "vi-VN": "Vietnamese"
    },
    "month": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "notification_type": {
      "NEW_APPOINTMENT": "New appointment",
      "APPOINTMENT_CANCELLED": "Appointment cancelled by customer",
      "APPOINTMENT_MESSAGE": "New message",
      "BO_UPDATED": "Appointment updated by salon",
      "BO_CANCELLED": "Appointment cancelled by salon"
    },
    "weekday": {
      "MONDAY": "Monday",
      "TUESDAY": "Tuesday",
      "WEDNESDAY": "Wednesday",
      "THURSDAY": "Thursday",
      "FRIDAY": "Friday",
      "SATURDAY": "Saturday",
      "SUNDAY": "Sunday"
    },
    "weekday_short": {
      "MONDAY": "Mo.",
      "TUESDAY": "Tu.",
      "WEDNESDAY": "We.",
      "THURSDAY": "Th.",
      "FRIDAY": "Fr.",
      "SATURDAY": "Sa.",
      "SUNDAY": "Su."
    },
    "review_type": {
      "all": "All reviews",
      "internal_only": "Internal reviews only",
      "google_only": "Google reviews only"
    },
    "time": {
      "day": "day",
      "days": "days",
      "hour": "hour",
      "hours": "hours",
      "minute": "minute",
      "minutes": "minutes",
      "month": "month",
      "months": "months",
      "now": "now",
      "second": "second",
      "seconds": "seconds",
      "year": "year",
      "years": "years",
      "timestamp_in_future": "in {{time}}",
      "timestamp_in_the_past": "{{time}} ago",
      "today": "today"
    },
    "time_period": {
      "all": "All",
      "today": "Today",
      "yesterday": "Yesterday",
      "this_week": "This week",
      "this_month": "This month",
      "last_month": "Last month",
      "this_quarter": "This quarter",
      "last_quarter": "Last quarter",
      "this_year": "This year",
      "last_year": "Last year"
    },
    "text": {
      "deleted-service": "Deleted service",
      "deleted-staff": "Deleted staff",
      "deleted-staff-passive": "Deleted staff",
      "first-available-staff": "First available staff",
      "first-available-staff-passive": "First available staff",
      "other": "other",
      "others": "others",
      "to": "to",
      "walk_in_customer": "Walk-in customer"
    }
  }
}
